
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import './slider.css'
import slides from './mock.json';
import { CURRENT_URL } from '../../config/runtimeConfig';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';


function Slider() {
    const pagination = {
        clickable: true,
        // renderBullet: function (index, className) {
        //   return '<span class="' + className + '">' + (index + 1) + '</span>';
        // },
    };

    return (
        <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            spaceBetween={20}
            slidesPerView={1}
            loop={true}
            speed={2000}   //speed={6500}
            pagination={pagination}
            navigation={true}
            autoplay={{
                delay: 1500,  //  delay: 0,
                disableOnInteraction: false,
            }}
            className="mySwiper"
        >
            {
                slides.map(slide => (
                    <SwiperSlide key={slide.image}>
                        <picture>
                            {/* <source media="(min-width: 1100px)" srcSet={`${process.env.REACT_APP_CURRENT_URL}/slides/${slide.image}`} />
                            <source media="(min-width: 480px)" srcSet={`${process.env.REACT_APP_CURRENT_URL}/slides/mob_${slide.image}`} /> */}
                            <img src={`${CURRENT_URL}/slides/${slide.image}`} alt="IfItDoesntMatchAnyMedia" />
                        </picture>

                    </SwiperSlide>
                ))
            }
        </Swiper>
    )
}

export default Slider
